import Apis from "./apis"

export default function ValidateJsonSchemaPlugin() {
  return Apis
}



// WEBPACK FOOTER //
// ./src/plugins/validate-json-schema/index.js